import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "25",
  height: "24",
  viewBox: "0 0 25 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("g", { id: "cloud-upload" }, [
  /*#__PURE__*/_createElementVNode("path", {
    id: "Vector",
    d: "M7.1 15.6C6.02543 15.5986 4.99227 15.1853 4.21313 14.4453C3.43398 13.7053 2.96811 12.6948 2.91138 11.6217C2.85465 10.5486 3.21138 9.49465 3.90816 8.6766C4.60494 7.85856 5.58877 7.3387 6.6572 7.22399C6.3426 5.99026 6.53098 4.68208 7.18091 3.58724C7.83084 2.49241 8.88907 1.70059 10.1228 1.38599C11.3565 1.07139 12.6647 1.25978 13.7595 1.9097C14.8544 2.55963 15.6462 3.61786 15.9608 4.85159C16.6945 4.74943 17.4414 4.79933 18.1551 4.99819C18.8687 5.19705 19.5338 5.54062 20.1089 6.00753C20.6841 6.47444 21.157 7.0547 21.4983 7.71221C21.8396 8.36972 22.042 9.09043 22.0928 9.8295C22.1436 10.5686 22.0418 11.3102 21.7938 12.0082C21.5457 12.7063 21.1566 13.3458 20.6508 13.8871C20.145 14.4283 19.5332 14.8597 18.8535 15.1544C18.1739 15.4491 17.4408 15.6007 16.7 15.6H13.7V11.2956L15.2516 12.8472C15.4779 13.0658 15.781 13.1867 16.0957 13.184C16.4103 13.1813 16.7113 13.0551 16.9338 12.8326C17.1563 12.6101 17.2825 12.3091 17.2852 11.9945C17.2879 11.6798 17.167 11.3767 16.9484 11.1504L13.3484 7.55039C13.1234 7.32543 12.8182 7.19905 12.5 7.19905C12.1818 7.19905 11.8766 7.32543 11.6516 7.55039L8.0516 11.1504C7.83301 11.3767 7.71206 11.6798 7.71479 11.9945C7.71752 12.3091 7.84373 12.6101 8.06622 12.8326C8.28871 13.0551 8.58968 13.1813 8.90432 13.184C9.21895 13.1867 9.52208 13.0658 9.7484 12.8472L11.3 11.2968V15.6H7.1Z",
    fill: "currentColor"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    id: "Vector_2",
    d: "M11.3 15.6H13.7V21.6C13.7 21.9182 13.5736 22.2235 13.3486 22.4485C13.1235 22.6735 12.8183 22.8 12.5 22.8C12.1818 22.8 11.8766 22.6735 11.6515 22.4485C11.4265 22.2235 11.3 21.9182 11.3 21.6V15.6Z",
    fill: "currentColor"
  })
], -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}